import SmallPopupDefaultTemplate from "components/templates/modal/small/SmallPopupDefaultTemplate";
import BigButton from "components/atoms/buttons/BigButton";
import styled from "styled-components";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";

type Props = {
  onConfirmCancel: () => void;
  onConfirm: (option?: any) => void;
  children?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  disabled?: boolean;
  "data-testid"?: string;
};

export default function NormalConfirmModal({
  onConfirmCancel,
  onConfirm,
  children,
  confirmLabel = "Yes",
  cancelLabel = "No",
  disabled = false,
  "data-testid": dataTestId,
}: Props): JSX.Element {
  return (
    <SmallPopupDefaultTemplate
      onModal={onConfirmCancel}
      button={
        <ButtonWrapper>
          <BigButton
            buttonType="cancel"
            label={cancelLabel}
            onClickBtn={onConfirmCancel}
            data-testid={`${
              dataTestId ?? "templates-modal-normal-big"
            }-button-confirm-cancel`}
          />

          <BigButton
            label={confirmLabel}
            onClickBtn={onConfirm}
            disabled={disabled}
            data-testid={`${
              dataTestId ?? "templates-modal-normal-big"
            }-button-confirm`}
          />
        </ButtonWrapper>
      }
    >
      <TextWrapper>{children}</TextWrapper>
    </SmallPopupDefaultTemplate>
  );
}
export const TextWrapper = styled.div`
  text-align: center;
  padding: 20px 0;
  line-height: ${calcRem(28)};
`;

const ButtonWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 10px;
`;
